import Vue from "vue";
import Router from "vue-router";
import Leaflet from "../views/others/Leaflet.vue";
import homeQueue from "../views/homeQueue.vue";
import ListSpaces from "../views/desktop/ListSpaces.vue";
import ListSpacesMobile from "../views/mobile/ListSpacesMobile.vue";
import ResumeSpace from "../views/desktop/ResumeSpace.vue";
import ResumeSpaceMobile from "../views/mobile/ResumeSpaceMobile.vue";
import EditContentMobile from "../views/mobile/EditContentMobile.vue";
import Queues from "../views/desktop/QueuesList.vue";
import QueuesMobile from "../views/mobile/QueuesListMobile.vue";
import QueueDetails from "../views/desktop/QueueDetails.vue";
import QueueDetailsMobile from "../views/mobile/QueueDetailsMobile.vue";
import QueueStandTurn from "../views/desktop/QueueStandTurn.vue";
import QueueStandTurnMobile from "../views/mobile/QueueStandTurnMobile.vue";
import GeneralStandTurn from "../views/desktop/GeneralStandTurn.vue";
import GeneralStandTurnMobile from "../views/mobile/GeneralStandTurnMobile.vue";
import Cloud from "../views/desktop/Cloud.vue";
import GeneralMap from "../views/desktop/GeneralMap.vue";
import Dashboard from "../views/desktop/Dashboard.vue";



Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "ListSpaces",
    component: ListSpaces
  },
  {
    path: "/ListSpacesMobile",
    name: "ListSpacesMobile",
    component: ListSpacesMobile
  },
  {
    path: "/homeQueue",
    name: "homeQueue",
    component: homeQueue
  },
  {
    path: "/ResumeSpace",
    name: "ResumeSpace",
    component: ResumeSpace
  },
  {
    path: "/ResumeSpaceMobile",
    name: "ResumeSpaceMobile",
    component: ResumeSpaceMobile
  },
  {
    path: "/EditContentMobile",
    name: "EditContentMobile",
    component: EditContentMobile
  },
  {
    path: "/Queues",
    name: "Queues",
    component: Queues
  },
  {
    path: "/QueuesMobile",
    name: "QueuesMobile",
    component: QueuesMobile
  },
  {
    path: "/queueDetails",
    name: "QueueDetails",
    component: QueueDetails
  },
  {
    path: "/QueueDetailsMobile",
    name: "QueueDetailsMobile",
    component: QueueDetailsMobile
  },
  {
    path: "/GeneralStandTurn",
    name: "GeneralStandTurn",
    component: GeneralStandTurn
  },
  {
    path: "/GeneralStandTurnMobile",
    name: "GeneralStandTurnMobile",
    component: GeneralStandTurnMobile
  },
  {
    path: "/QueueStandTurn",
    name: "QueueStandTurn",
    component: QueueStandTurn
  },
  {
    path: "/QueueStandTurnMobile",
    name: "QueueStandTurnMobile",
    component: QueueStandTurnMobile
  },
  {
    path: "/Cloud",
    name: "Cloud",
    component: Cloud
  },
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/GeneralMap",
    name: "GeneralMap",
    component: GeneralMap
  },
  {
    path: "/leaflet",
    name: "Leaflet",
    component: Leaflet
  },
];

// var mobile = {
//   Android: function() {
//     return navigator.userAgent.match(/Android/i);
//   },
//   BlackBerry: function() {
//     return navigator.userAgent.match(/BlackBerry/i);
//   },
//   iOS: function() {
//     return navigator.userAgent.match(/iPhone|iPad|iPod/i);
//   },
//   Opera: function() {
//     return navigator.userAgent.match(/Opera Mini/i);
//   },
//   Windows: function() {
//     return navigator.userAgent.match(/IEMobile/i);
//   },
//   any: function() {
//     return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
//   }
// };

// if(mobile.any() != null){
//   routes[0].name = "ListSpacesMobile"
//   routes[0].component = ListSpacesMobile
// }

const router = new Router({
  mode: "history",
  routes
});

// Proceso de validación de rutas
router.beforeEach((to, from, next) => {
  const userRol = localStorage.getItem("rol");

  const proposalsAuth = to.matched.some(record => record.meta.proposals);
  const settingsAuth = to.matched.some(record => record.meta.settings);
  const locationsAuth = to.matched.some(record => record.meta.locations);
  const devicesAuth = to.matched.some(record => record.meta.devices);

  if (
    (proposalsAuth && userRol == 3) ||
    (proposalsAuth && userRol == 5) ||
    (proposalsAuth && userRol == 8) ||
    (proposalsAuth && userRol == 10)
  ) {
    next({ path: "/" });
  } else if (
    (settingsAuth && userRol == 5) ||
    (settingsAuth && userRol == 8) ||
    (settingsAuth && userRol == 9) ||
    (settingsAuth && userRol == 10)
  ) {
    next({ path: "/" });
  } else if (
    (locationsAuth && userRol == 8) ||
    (locationsAuth && userRol == 10)
    ) {
    next({ path: "/" });
  } else if (
    (devicesAuth && userRol == 8) ||
    (devicesAuth && userRol == 10)
    ) {
    next({ path: "/" });
  } else {
    next();
  }

  //const rutaProtegida = to.matched.some(record => record.meta.requireAuth);
  // Comprobar si es una ruta protegida y que deba tener un token válido
  //store.state.userData.accessToken == ""
  //const token = localStorage.getItem("accessToken");
  // if (rutaProtegida && store.state.userData.accessToken == "") {
  //   next(location.replace(response.data));
  // } else {
  //   next();
  // }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js